/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function r(r){let e,t;return r.replace(/^(.*\/)?([^/]*)$/,(r,a,i)=>(e=a||"",t=i||"","")),{dirPart:e,filePart:t}}export{r as splitURI};
